import { c as useUserServiceNavigationSettings, F as FAVORITES } from './useAccountSettings-c4419af2.js';
import { ref, computed } from 'vue-demi';
import { SERVICES } from './constants/index.js';

function useUserServiceNavigationFavoritesServicesSettings(token, config) {
  const state = ref(null);
  const {
    getUserServiceNavigationSettings,
    setUserServiceNavigationSettings
  } = useUserServiceNavigationSettings(token, config, FAVORITES);
  const getUserFavoritesServices = computed({
    get() {
      if (!Array.isArray(state.value)) {
        getUserServiceNavigationSettings.value().then(fs => {
          if (fs === null || fs === void 0 ? void 0 : fs.length) {
            if (Object.keys(SERVICES).some(key => fs.includes(key))) {
              // fixing deprecated keys
              state.value = fs === null || fs === void 0 ? void 0 : fs.map(key => {
                var _a;
                return (_a = SERVICES[key]) !== null && _a !== void 0 ? _a : key;
              });
              setUserServiceNavigationSettings.value(state.value);
            } else {
              state.value = fs || [];
            }
          }
        });
      }
      return state.value;
    },
    set(data) {
      var _a;
      state.value = (_a = data === null || data === void 0 ? void 0 : data.map(key => {
        var _a;
        return (_a = SERVICES[key]) !== null && _a !== void 0 ? _a : key;
      })) !== null && _a !== void 0 ? _a : null;
    }
  });
  const addToUserFavoritesServices = item => {
    if (item) {
      const value = getUserFavoritesServices.value || [];
      getUserFavoritesServices.value = [...value, item];
      setUserServiceNavigationSettings.value(getUserFavoritesServices.value);
    }
  };
  const removeFromUserFavoritesServices = item => {
    if (item) {
      getUserFavoritesServices.value = (getUserFavoritesServices.value || []).filter(i => i !== item);
      setUserServiceNavigationSettings.value(getUserFavoritesServices.value);
    }
  };
  const toggleUserFavoritesServices = item => {
    (getUserFavoritesServices.value || []).indexOf(item) === -1 ? addToUserFavoritesServices(item) : removeFromUserFavoritesServices(item);
  };
  return {
    addToUserFavoritesServices,
    removeFromUserFavoritesServices,
    toggleUserFavoritesServices,
    getUserFavoritesServices
  };
}

export { useUserServiceNavigationFavoritesServicesSettings as u };
